(function (window, document) {
    const scrollUpButton = document.querySelector('.scrollUpButton');

    function scrollToTop() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    window.addEventListener('scroll', function () {
        if (window.scrollY > 200) {
            scrollUpButton.style.display = 'block';
        } else {
            scrollUpButton.style.display = 'none';
        }
    });

    scrollUpButton.addEventListener('click', scrollToTop);
})(window, document);
